import { Outlet, createFileRoute, useSearch } from '@tanstack/react-router';
import { NavbarPublic as Navbar } from '@/components/layout/navbar/navbar.public';
import Footer from '@/components/layout/footer';

export const Route = createFileRoute('/(consumer)/_public')({
  component: RouteComponent,
});

function RouteComponent() {
  const search = useSearch({ from: '/(consumer)/_public' });
  const isEmbedded =
    (search as Record<string, unknown>)?.embed === 'mobile-view';

  if (isEmbedded) {
    return <Outlet />;
  }

  return (
    <>
      <Navbar />
      <Outlet />
      <Footer />
    </>
  );
}
